import { render, staticRenderFns } from "./FichePortraitIndexTextuelCommon.vue?vue&type=template&id=2d50d12a&"
import script from "./FichePortraitIndexTextuelCommon.vue?vue&type=script&lang=js&"
export * from "./FichePortraitIndexTextuelCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports